import {
  embedScript as publicEmbedScript,
  getEmbeddedScript as publicGetEmbeddedScript,
} from './devcenter-scripts-v1-script-properties-embedded-scripts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const embedScript: MaybeContext<
  BuildRESTFunction<typeof publicEmbedScript> & typeof publicEmbedScript
> = /*#__PURE__*/ createRESTModule(publicEmbedScript);
export const getEmbeddedScript: MaybeContext<
  BuildRESTFunction<typeof publicGetEmbeddedScript> &
    typeof publicGetEmbeddedScript
> = /*#__PURE__*/ createRESTModule(publicGetEmbeddedScript);

export {
  ScriptProperties,
  EmbedScriptRequest,
  EmbedScriptResponse,
  GetEmbeddedScriptRequest,
  GetEmbeddedScriptResponse,
  EmbedScriptByInstanceIdRequest,
  GetEmbeddedScriptByInstanceIdRequest,
  EmbedScriptOptions,
  GetEmbeddedScriptOptions,
} from './devcenter-scripts-v1-script-properties-embedded-scripts.universal.js';
